module.exports = __webpack_public_path__ + "img/huankuanchenggong.c4615ffb.png";